import 'smartbanner.js/dist/smartbanner.min.js'
import 'smartbanner.js/dist/smartbanner.min.css'
